angular.module('ikeweb.routes').config(['$stateProvider', '$urlRouterProvider', 'routes',

    function($stateProvider, $urlRouterProvider, routes) {

        $urlRouterProvider.otherwise(routes.GALLERY.url);

        $stateProvider
            .state('login', routes.LOG_IN)
            .state('signup', routes.SIGN_UP)
            .state('choose_password', routes.CHOOSE_PASSWORD)
            .state('invalid_link', routes.INVALID_LINK)
            .state('password_reset_success', routes.PASSWORD_RESET_SUCCESS)
            .state('forgotPassword', routes.FORGOT_PASSWORD)
            .state('gallery', routes.GALLERY)
            .state('capture', routes.PHOTOMEASURE)
            .state('align', routes.ALIGN)
            .state('measure', routes.MEASURE)
            .state('report', routes.REPORT)
            .state('billing', routes.BILLING)
            .state('shared', routes.SHARED_REPORT)
            .state('map', routes.MAP)
            .state('error', routes.ERROR);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/routes/routes.config.js
// module id = 157
// module chunks = 0